module.exports = __webpack_public_path__ + "img/before-4.f89c4072.png";